import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

import { computed, reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Tag',
  props: ["tag", "removable"],
  emits: ["remove", "select"],
  setup(__props, { emit }) {

const props = __props;




const select = () => {
  emit("select", props.tag);
};

const remove = () => {
  emit("remove", props.tag);
};

const styleObject = computed(() => ({
  background: props.tag.style?.background,
  border: `2px solid ${props.tag.style?.border}`,
  color: props.tag.style?.color,
  "font-weight": "600",
  "width": "fit-content"
}));

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_chip = _resolveComponent("q-chip")!

  return (_openBlock(), _createBlock(_component_q_chip, {
    clickable: "",
    onClick: select,
    onRemove: remove,
    removable: props.removable,
    style: _normalizeStyle(_unref(styleObject))
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(props.tag.title) + " ", 1),
      (props.tag.description)
        ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.tag.description), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["removable", "style"]))
}
}

})